import Header from "@/components/header/Header";
import { ReactNode } from "react";
import { useLocation } from "react-router-dom";

interface Props {
  children: ReactNode;
}

export default function MainLayout({ children }: Props) {
  const { pathname } = useLocation();
  const isAuthPage = ["/login", "/signup", "/auth/callback"].includes(pathname);

  return (
    <>
      {!isAuthPage && <Header />}
      <main>{children}</main>
    </>
  );
}
